import "./messages";
import type { ModuleDefinition } from "../types";
import { BILLING_READ } from "./permissions";

const screens = () => import("./screens");

/** Billing runs, minimum and statement close. Entitled by the billing license. */
/** Billing runs and closes: not for people who only post or take payments at a counter. */
const backOffice = { when: ["billing.post", "billing.payments"], unless: ["billing.runs", "billing.close", "billing.settings", "billing.adjust"] };

export const accountingModule: ModuleDefinition = {
  id: "accounting",
  licenseModule: "billing",
  labelKey: "module.accounting",
  nav: [
    { id: "accounting-jonas", labelKey: "accounting.jonasChart.title", to: "/accounting/jonas", icon: "log", permission: "accounting.import" },
    { id: "accounting-runs", labelKey: "accounting.nav.runs", to: "/accounting/runs", icon: "refresh", permission: BILLING_READ, backOffice },
    { id: "accounting-minimum", labelKey: "accounting.nav.minimum", to: "/accounting/minimum", icon: "flag", permission: BILLING_READ, backOffice },
    { id: "accounting-statements", labelKey: "accounting.nav.statements", to: "/accounting/statements", icon: "lock", permission: BILLING_READ, backOffice },
  ],
  routes: [
    { path: "accounting/jonas", permission: "accounting.import", load: () => import("./screens/JonasChartReviewPage") },
    { path: "accounting/runs", permission: BILLING_READ, load: async () => ({ default: (await screens()).RunsPage }) },
    { path: "accounting/runs/:runId", permission: BILLING_READ, load: async () => ({ default: (await screens()).RunPage }) },
    { path: "accounting/minimum", permission: BILLING_READ, load: async () => ({ default: (await screens()).MinimumPage }) },
    { path: "accounting/statements", permission: BILLING_READ, load: async () => ({ default: (await screens()).StatementsPage }) },
    { path: "accounting/statements/runs/:runId", permission: BILLING_READ, load: async () => ({ default: (await screens()).StatementRunPage }) },
  ],
};
